// extracted by mini-css-extract-plugin
export var accordion = "style-module--accordion--ff7e7";
export var accordion__block = "style-module--accordion__block--f3cde";
export var accordion__skillsCard = "style-module--accordion__skills-card--b82b2";
export var accordion__skillsCardText = "style-module--accordion__skills-card-text--003f9";
export var accordion__skillsItemClassesName = "style-module--accordion__skills-item-classes-name--18606";
export var accordion__skillsNumText = "style-module--accordion__skills-num-text--a77ee";
export var bage = "style-module--bage--14a95";
export var cards = "style-module--cards--10246";
export var cardsHeader = "style-module--cards-header--4fd7c";
export var cardsItem = "style-module--cards-item--cde9b";
export var cardsNum = "style-module--cards-num--310ed";
export var cardsNumLg = "style-module--cards-num--lg--d9853";
export var cardsTxt = "style-module--cards-txt--22a3b";
export var cardsTxtSm = "style-module--cards-txt--sm--8f42b";
export var content = "style-module--content--a2de7";
export var description = "style-module--description--99d89";
export var header = "style-module--header--2e0ae";
export var res = "style-module--res--21727";
export var resCol = "style-module--res-col--c075e";
export var resRow = "style-module--res-row--f1911";
export var resText = "style-module--res-text--645c9";
export var resTitle = "style-module--res-title--95f70";
export var skillsItem = "style-module--skills-item--1f669";
export var skillsItemClasses = "style-module--skills-item--classes--6c45e";
export var skillsList = "style-module--skills-list--95e93";
export var skillsListCol = "style-module--skills-list-col--c6e0e";
export var skillsTitle = "style-module--skills-title--5c45c";
export var skillsWrap = "style-module--skills-wrap--5026d";
export var structure = "style-module--structure--d5c81";
export var structure__video = "style-module--structure__video--4485d";
export var structure__videoTitle = "style-module--structure__video-title--0107c";
export var text = "style-module--text--55fdd";
export var title = "style-module--title--e212c";